
import {createAsyncThunk, createSlice, current} from '@reduxjs/toolkit';

const initialState = {
    rechargeUserInfo: ""
};

export const SchoolInfoManagerSlice = createSlice({
    name: 'schoolInfoManager',
    initialState,
    reducers: {
        setRechargeUserInfo: (state,action) => {
            state.rechargeUserInfo = action.payload;
        }
    },
});

export const selectRechargeUserInfo = (state) => state.schoolInfoManager.rechargeUserInfo;
export const {
    setRechargeUserInfo
} = SchoolInfoManagerSlice.actions;

export default SchoolInfoManagerSlice.reducer;
